import { gql } from '@apollo/client';
import edit from './Edit';
import list from './List';
import show from './Show';

export default {
  name: 'professional_saas_detail',
  inputShow: gql`
    query professionalSaasDetails($input: ProfessionalSaasDetailQueryInput) {
      professionalSaasDetails(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  edit,
  show,
  options: {
    group: 'Misc',
    label: 'Professional Saas Details',
  },
};
